import { render, staticRenderFns } from "./message.vue?vue&type=template&id=6fa2ab3c&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=6fa2ab3c&prod&scoped=true&lang=css&external"
import style1 from "./message.vue?vue&type=style&index=1&id=6fa2ab3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2ab3c",
  null
  
)

export default component.exports